var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "reservation" } },
    [
      !_vm.$route.params.id ||
      (!!_vm.$route.params.id && Object.keys(_vm.reservationPlan).length > 0)
        ? _c(
            "a-spin",
            {
              staticStyle: { width: "100%", display: "flex" },
              attrs: { spinning: _vm.loading },
            },
            [
              _c("div", { staticClass: "left" }, [
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("calendar.appointProgram"))),
                    ]),
                    _vm._v(" "),
                    !!this.$route.params.id
                      ? _c(
                          "SupsisButton",
                          {
                            staticClass: "go-link",
                            on: {
                              click: function ($event) {
                                return _vm.goLink()
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons icon" }, [
                              _vm._v("open_in_new"),
                            ]),
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("message.goToLink")) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-area" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.title,
                            expression: "title",
                          },
                        ],
                        staticClass: "label-input",
                        attrs: {
                          placeholder: _vm.$t("message.newTitleContent"),
                        },
                        domProps: { value: _vm.title },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.title = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm.pageNumber === 1
                      ? _c(
                          "div",
                          [
                            _c("Duration", {
                              model: {
                                value: _vm.duration,
                                callback: function ($$v) {
                                  _vm.duration = $$v
                                },
                                expression: "duration",
                              },
                            }),
                            _vm._v(" "),
                            _c("Availability", {
                              model: {
                                value: _vm.availability,
                                callback: function ($$v) {
                                  _vm.availability = $$v
                                },
                                expression: "availability",
                              },
                            }),
                            _vm._v(" "),
                            _c("Plan", {
                              model: {
                                value: _vm.plan,
                                callback: function ($$v) {
                                  _vm.plan = $$v
                                },
                                expression: "plan",
                              },
                            }),
                            _vm._v(" "),
                            _c("Setting", {
                              model: {
                                value: _vm.setting,
                                callback: function ($$v) {
                                  _vm.setting = $$v
                                },
                                expression: "setting",
                              },
                            }),
                            _vm._v(" "),
                            _c("Calendar", {
                              model: {
                                value: _vm.calendarData,
                                callback: function ($$v) {
                                  _vm.calendarData = $$v
                                },
                                expression: "calendarData",
                              },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c("Description", {
                              model: {
                                value: _vm.description,
                                callback: function ($$v) {
                                  _vm.description = $$v
                                },
                                expression: "description",
                              },
                            }),
                            _vm._v(" "),
                            _c("Form", {
                              model: {
                                value: _vm.formInputs,
                                callback: function ($$v) {
                                  _vm.formInputs = $$v
                                },
                                expression: "formInputs",
                              },
                            }),
                          ],
                          1
                        ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "footer" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        staticClass: "btn back",
                        on: {
                          click: function ($event) {
                            return _vm.backPage()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("wp.wpBack")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        staticClass: "btn preview",
                        on: {
                          click: function ($event) {
                            return _vm.preview()
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "material-icons preview-icon" },
                          [_vm._v("visibility")]
                        ),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("chatbotv2.preview")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        staticClass: "btn",
                        on: {
                          click: function ($event) {
                            return _vm.nextPage()
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.pageNumber === 1
                              ? _vm.$t("message.forward")
                              : _vm.$t("message.save")
                          ) + "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c("FullCalendar", {
                    ref: "calendar",
                    attrs: { options: _vm.calendarOptions },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }